import { AppBar, Box, Drawer } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SIDEBAR_WIDTH = 240;
export const COLLAPSED_SIDEBAR_WIDTH = 64;
export const APPBAR_HEIGHT = 64;

export const Root = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
});

export const ContentWrapper = styled(Box)({
  display: 'flex',
  flexGrow: 1,
});

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  height: APPBAR_HEIGHT,
  justifyContent: 'center',
  boxShadow: theme.shadows[1],
}));

export const StyledDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== 'collapsed',
})<{ collapsed?: boolean }>(({ theme, collapsed }) => ({
  width: collapsed ? COLLAPSED_SIDEBAR_WIDTH : SIDEBAR_WIDTH,
  flexShrink: 0,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  '& .MuiDrawer-paper': {
    width: collapsed ? COLLAPSED_SIDEBAR_WIDTH : SIDEBAR_WIDTH,
    boxSizing: 'border-box',
    marginTop: `${APPBAR_HEIGHT}px`,
    height: `calc(100vh - ${APPBAR_HEIGHT}px)`,
    overflowX: 'hidden',
    position: 'sticky',
    top: 0,
    alignSelf: 'flex-start',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
}));

// Renders as <main> to provide semantic HTML landmark for accessibility
export const MainContent = styled('main')(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  marginTop: `${APPBAR_HEIGHT}px`,
  backgroundColor: theme.palette.background.default,
  overflowX: 'hidden',
}));
